module.exports = __webpack_public_path__ + "static/media/plate_landing.facb3252.webp";